import React, { FC } from "react";
import ToggleButtonGroup, {
  ToggleButtonGroupProps,
} from "@mui/material/ToggleButtonGroup";
import { tss } from "tss-react/mui";

const useStyles = tss.create(({ theme }) => ({
  root: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
  },
  grouped: {
    transition: theme.transitions.create([
      "color",
      "background-color",
      "border-color",
    ]),
    "&:not(:last-of-type)": {
      borderRight: 0,
    },
    "&:not(:first-of-type)": {
      borderLeft: 0,
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
}));

const StyledToggleButtonGroup: FC<ToggleButtonGroupProps> = (props) => {
  const { classes } = useStyles();

  return (
    <ToggleButtonGroup
      classes={{ root: classes.root, grouped: classes.grouped }}
      exclusive
      {...props}
    />
  );
};

export default StyledToggleButtonGroup;
